import { DropdownItem } from '../AROKMS/TableDefinitionTypes';

export interface CubeLayerSetItem {
  id: string;
  code: string;
  name: string;
  description: string;
  layers: DropdownItem[];
  type: DropdownItem;
}

export interface CubeLayerSetRowItem extends CubeLayerSetItem {
  isNew?: boolean;
}

export interface RequestCreateCubeLayerSet {
  id?: number | undefined | null | string;
  name: string;
  description: string;
  layers: string[];
}

export const CUBE_LAYER_REMOVAL_BLOCKED_ERROR_CODE = 'CUBE_LAYER_REMOVAL_BLOCKED';

export interface CubeLayerRemovalDependencyCube {
  id: string | null;
  code: string | null;
  name: string;
  subjectId: string | null;
}

export interface CubeLayerRemovalDependencyLayer {
  id: string | null;
  name: string;
}

export interface CubeLayerRemovalDependency {
  type: string;
  sourceCube?: CubeLayerRemovalDependencyCube | null;
  destinationCube?: CubeLayerRemovalDependencyCube | null;
  sourceLayer?: CubeLayerRemovalDependencyLayer | null;
  destinationLayer?: CubeLayerRemovalDependencyLayer | null;
  /** Display names supplied by the API. Attribute codes must not be shown in the default error UI. */
  attributes: string[];
}

export interface CubeLayerRemovalBlockedDetails {
  layerId: string;
  layerName: string;
  affectedCube: CubeLayerRemovalDependencyCube;
  dependencyType: 'CUBE_LAYER_MAPPING';
  dependencyCount: number;
  dependencies: CubeLayerRemovalDependency[];
}

export interface CubeLayerRemovalBlockedErrorResponse {
  status: number;
  code: typeof CUBE_LAYER_REMOVAL_BLOCKED_ERROR_CODE;
  message: string;
  requestId?: string;
  details: CubeLayerRemovalBlockedDetails;
}
